module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"placeholder_phone_number":"Номер телефона"}}')
  delete Component.options._Ctor
}
